import { styled } from '@mui/material/styles';
import { Dialog, Box } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: theme.shape.borderRadius * 2,
    },
}));

export const StyledDialogContent = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
})); 